import {
  UPSERT_PACKAGE_INSTALLER,
  UPSERT_PACKAGE_INSTALLER_SUCCESS,
  UPSERT_PACKAGE_INSTALLER_FAIL,
  GET_LIST_PACKAGE_INSTALLER,
  GET_LIST_PACKAGE_INSTALLER_SUCCESS,
  GET_LIST_PACKAGE_INSTALLER_FAIL,
  INACTIVE_PACKAGE_INSTALLER,
  INACTIVE_PACKAGE_INSTALLER_SUCCESS,
  INACTIVE_PACKAGE_INSTALLER_FAIL,
  FILTER_PACKAGE_INSTALLER,
  FILTER_LOADING_PACKAGE_INSTALLER,
  RESET_PACKAGE_INSTALLER_FLAG
} from "./actionTypes"

export const upsertPackageInstaller = data => ({
  type: UPSERT_PACKAGE_INSTALLER,
  payload: data
})
export const upsertPackageInstallerSuccess = event => ({
  type: UPSERT_PACKAGE_INSTALLER_SUCCESS,
  payload: event
})
export const upsertPackageInstallerFail = error => ({
  type: UPSERT_PACKAGE_INSTALLER_FAIL,
  payload: error
})

export const getListPackageInstaller = () => ({
  type: GET_LIST_PACKAGE_INSTALLER
})
export const getListPackageInstallerSuccess = event => ({
  type: GET_LIST_PACKAGE_INSTALLER_SUCCESS,
  payload: event
})
export const getListPackageInstallerFail = error => ({
  type: GET_LIST_PACKAGE_INSTALLER_FAIL,
  payload: error
})

export const inactivePackageInstaller = data => ({
  type: INACTIVE_PACKAGE_INSTALLER,
  payload: data
})
export const inactivePackageInstallerSuccess = event => ({
  type: INACTIVE_PACKAGE_INSTALLER_SUCCESS,
  payload: event
})
export const inactivePackageInstallerFail = error => ({
  type: INACTIVE_PACKAGE_INSTALLER_FAIL,
  payload: error
})

export const filterPackageInstaller = data => ({
  type: FILTER_PACKAGE_INSTALLER,
  payload: data
})
export const filterLoadingPackageInstaller = data => ({
  type: FILTER_LOADING_PACKAGE_INSTALLER,
  payload: data
})

export const resetPackageInstallerFlag = () => ({
  type: RESET_PACKAGE_INSTALLER_FLAG
})
